import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-textarea-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './textarea-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './textarea-field.component.css',
})
export class TextareaFieldComponent extends FieldType<FieldTypeConfig> {}
